/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiCustomListsDtoCustomListBulkItemDto } from './WebApiCustomListsDtoCustomListBulkItemDto';
import {
    WebApiCustomListsDtoCustomListBulkItemDtoFromJSON,
    WebApiCustomListsDtoCustomListBulkItemDtoFromJSONTyped,
    WebApiCustomListsDtoCustomListBulkItemDtoToJSON,
} from './WebApiCustomListsDtoCustomListBulkItemDto';

/**
 * 
 * @export
 * @interface WebApiCustomListsDtoCreateBulkCustomListDto
 */
export interface WebApiCustomListsDtoCreateBulkCustomListDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCreateBulkCustomListDto
     */
    listId?: number;
    /**
     * 
     * @type {Array<WebApiCustomListsDtoCustomListBulkItemDto>}
     * @memberof WebApiCustomListsDtoCreateBulkCustomListDto
     */
    items?: Array<WebApiCustomListsDtoCustomListBulkItemDto> | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoCreateBulkCustomListDto interface.
 */
export function instanceOfWebApiCustomListsDtoCreateBulkCustomListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoCreateBulkCustomListDtoFromJSON(json: any): WebApiCustomListsDtoCreateBulkCustomListDto {
    return WebApiCustomListsDtoCreateBulkCustomListDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoCreateBulkCustomListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoCreateBulkCustomListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'listId': !exists(json, 'listId') ? undefined : json['listId'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(WebApiCustomListsDtoCustomListBulkItemDtoFromJSON)),
    };
}

export function WebApiCustomListsDtoCreateBulkCustomListDtoToJSON(value?: WebApiCustomListsDtoCreateBulkCustomListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'listId': value.listId,
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(WebApiCustomListsDtoCustomListBulkItemDtoToJSON)),
    };
}

